/* eslint-disable no-console */
export default ( ms, promiseOrFunction ) => {
    return new Promise((resolve, reject) => {        
        let timeout = setTimeout(() => reject("timed out"), ms);
        let promise;
        if ("then" in promiseOrFunction) {
          promise = promiseOrFunction;
        } else {
          promise = Promise.resolve(promiseOrFunction());
        }
        promise
          .then((result) => {            
            clearTimeout(timeout);
            resolve(result);
          })
          .catch((error) => {            
            clearTimeout(timeout);
            reject(error);
          });
      });
};